import Dexie from 'dexie';

  export const store = new Dexie('gta');
  store.version(1).stores({
    currentEdits: 'type',
    quizCurr: 'uuid',
    savedCourses: '++id',
    savedQuiz: 'uuid'
  });